import Vue from 'vue';
import { MutationTree } from 'vuex';
import {
    AxiosState, ICancelerProp
} from './types';

interface MutationsType {
    PUSH_CANCELER: (state: AxiosState, payload: ICancelerProp) => void;
    REMOVE_CANCELER: (state: AxiosState, key: string) => void;
    RUN_CANCELER: (state: AxiosState, key: string) => void;
    RUN_ALL_CANCELERS: (state: AxiosState) => void;
    CLEAR_ALL_CANCELERS: (state: AxiosState) => void;
}

export const mutations: MutationTree<AxiosState> & MutationsType = {
    PUSH_CANCELER: (state: AxiosState, payload: ICancelerProp) => {
        Vue.set(state.cancels, payload.key, payload.canceler);
    },
    REMOVE_CANCELER: (state: AxiosState, key: string) => {
        Vue.delete(state.cancels, key);
    },
    RUN_CANCELER: (state: AxiosState, key: string) => {
        const canceler = state.cancels[key];
        canceler && canceler();
        Vue.delete(state.cancels, key);
    },
    RUN_ALL_CANCELERS: (state: AxiosState) => {
        Object.keys(state.cancels).forEach((key: string) => {
            state.cancels[key]();
            Vue.delete(state.cancels, key);
        });
        state.cancels = {};
    },
    CLEAR_ALL_CANCELERS: (state: AxiosState) => {
        state.cancels = {};
    },
};
